import { render, staticRenderFns } from "./MagazineModal.vue?vue&type=template&id=3b0ad2cc&scoped=true"
import script from "./MagazineModal.vue?vue&type=script&lang=js"
export * from "./MagazineModal.vue?vue&type=script&lang=js"
import style0 from "./MagazineModal.vue?vue&type=style&index=0&id=3b0ad2cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0ad2cc",
  null
  
)

export default component.exports